module.exports = __webpack_public_path__ + "static/media/audit-photo.be9ed210.png";